<!--
 * @Author: mazhigang
 * @Date: 2023-07-03 17:43:22
 * @LastEditors: xjf
 * @LastEditTime: 2025-02-07 16:47:13
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>邀请事件管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">事件列表</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="产品名称">
                  <el-select
                    v-model="ruleForm.name2"
                    placeholder="请选择产品名称"
                    style="margin-right: auto"
                  >
                    <el-option
                      :label="item.propDesc"
                      :value="item.propValue"
                      v-for="(item, index) in options"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="渠道名称">
                  <el-select
                    v-model="ruleForm.name1"
                    placeholder="请选择渠道名称"
                    style="margin-right: auto"
                  >
                    <el-option
                      :label="item.propDesc"
                      :value="item.propValue"
                      v-for="(item, index) in options1"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="时间">
                  <div style="display: flex; align-items: center">
                    <el-date-picker
                      v-model="ruleForm.time"
                      type="datetime"
                      placeholder="选择开始时间"
                      align="right"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                    <div style="margin: 0 5px">-</div>
                    <el-date-picker
                      v-model="ruleForm.time1"
                      type="datetime"
                      placeholder="选择结束时间"
                      align="right"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="事件说明">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入事件说明"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-button
          type="primary"
          class="btn"
          style="margin-bottom: 16px"
          @click="add()"
          >添加</el-button
        >
        <el-table ref="scrollTable" :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="编号" align="center">
          </el-table-column>
          <el-table-column
            label="产品名称"
            align="center"
            prop="productName"
          ></el-table-column>
          <el-table-column
            label="渠道名称"
            align="center"
            prop="platformName"
          ></el-table-column>
          <el-table-column label="事件说明" align="center" width="160">
            <template slot-scope="scope">
              <span class="soldText" @click="goLink(scope.row)">{{
                scope.row.eventDesc
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="创建日期"
            align="center"
            prop="gmtCreate"
            width="160"
          ></el-table-column>
          <el-table-column
            label="创建人"
            align="center"
            prop="creatorName"
          ></el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <div class="disAround">
                <div class="operateBtn redColor1" @click="seeDetail(scope.row)">
                  详情
                </div>
                <div class="operateBtn" @click="edit(scope.row)">编辑</div>
                <div
                  class="operateBtn redColor1"
                  @click="deleteItem(scope.row)"
                >
                  删除
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="600px">
      <el-form
        label-position="right"
        :model="ruleForm1"
        :rules="rules"
        ref="ruleForm"
        style="margin: 0 auto"
      >
        <el-form-item label="产品名称" prop="type">
          <el-select
            v-model="ruleForm1.type"
            placeholder="请选择"
            :disabled="disabled"
          >
            <el-option
              v-for="item in options"
              :key="item.propValue"
              :label="item.propDesc"
              :value="item.propValue"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道名称" prop="type1">
          <el-select
            v-model="ruleForm1.type1"
            placeholder="请选择"
            :disabled="disabled"
          >
            <el-option
              v-for="item in options1"
              :key="item.propValue"
              :label="item.propDesc"
              :value="item.propValue"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="事件链接" prop="deduction">
          <el-input
            :disabled="disabled"
            type="textarea"
            v-model="ruleForm1.deduction"
            placeholder="请输入事件链接"
          ></el-input>
        </el-form-item>
        <el-form-item label="事件说明" prop="memo">
          <el-input
            :disabled="disabled"
            type="textarea"
            v-model="ruleForm1.memo"
            placeholder="请输入事件说明"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetForm1('ruleForm')">取消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.operateData(),
      ruleForm: {
        name: "",
        name1: "",
        name2: "",
        time: "",
        time1: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dialogFormVisible: false,
      title: "新增事件",
      ruleForm1: {
        type: "",
        memo: "",
        deduction: "",
        type1: "",
      },
      rules: {
        type: [{ required: true, message: "必选项", trigger: "change" }],
        type1: [{ required: true, message: "必选项", trigger: "change" }],
        deduction: [{ required: true, message: "必选项", trigger: "blur" }],
        memo: [{ required: true, message: "必填项", trigger: "blur" }],
      },
      options: [],
      options1: [],
      editId: "",
      disabled: false,
    };
  },
  mounted() {
    this.getList();
    this.getList1();
    this.getList2();
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            eventDesc: this.ruleForm1.memo,
            eventUrl: this.ruleForm1.deduction,
            platformId: this.ruleForm1.type1,
            productId: this.ruleForm1.type,
          };
          if (this.editId == "") {
            this.$axios
              .post(`/admapi/invite/event/add`, param)
              .then(({ data }) => {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.getList();
              })
              .catch()
              .finally((this.dialogFormVisible = false));
          } else {
            param.id = this.editId;
            this.$axios
              .post(`/admapi/invite/event/update`, param)
              .then(({ data }) => {
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.getList();
              })
              .catch()
              .finally(() => {
                this.dialogFormVisible = false;
                this.editId = "";
                this.ruleForm1.type = "";
                this.ruleForm1.memo = "";
                this.ruleForm1.money = "";
                this.ruleForm1.time = "";
                this.ruleForm1.num = "";
                this.ruleForm1.deduction = "";
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm1(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
    },
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.name1 = "";
      this.ruleForm.name2 = "";
      this.ruleForm.time = "";
      this.ruleForm.time1 = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        startTime: this.ruleForm.time,
        endTime: this.ruleForm.time1,
        eventDesc: this.ruleForm.name,
        platformId: this.ruleForm.name1,
        productId: this.ruleForm.name2,
      };
      this.$axios
        .post(`/admapi/invite/event/list`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
    add() {
      this.disabled = false;
      this.title = "新增事件";
      this.dialogFormVisible = true;
      this.editId = "";
      this.ruleForm1.type = "";
      this.ruleForm1.type1 = "";
      this.ruleForm1.deduction = "";
      this.ruleForm1.memo = "";
    },
    edit(val) {
      this.editId = val.id;
      this.title = "编辑事件";
      this.dialogFormVisible = true;
      this.disabled = false;
      this.getDetail();
    },
    seeDetail(val) {
      this.editId = val.id;
      this.title = "查看事件";
      this.dialogFormVisible = true;
      this.disabled = true;
      this.getDetail();
    },
    getDetail() {
      this.$axios
        .post(`/admapi/invite/event/get/${this.editId}`)
        .then(({ data }) => {
          this.ruleForm1.type = JSON.stringify(data.productId);
          this.ruleForm1.type1 = JSON.stringify(data.platformId);
          this.ruleForm1.deduction = data.eventUrl;
          this.ruleForm1.memo = data.eventDesc;
        })
        .catch()
        .finally();
    },
    deleteItem(val) {
      this.$confirm("是否删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`/admapi/invite/event/delete/${val.id}`)
            .then(({ data }) => {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    getList1() {
      let param = {
        page: 1,
        pageSize: 99999,
        queryParams: [
          {
            name: "prop_name",
            type: "input",
            value: "inviteEventProduct",
          },
        ],
      };
      this.$axios
        .post(`/admapi/sys/conf/list`, param)
        .then(({ data }) => {
          this.options = data.items;
        })
        .catch()
        .finally();
    },
    getList2() {
      let param = {
        page: 1,
        pageSize: 99999,
        queryParams: [
          {
            name: "prop_name",
            type: "input",
            value: "inviteEventPlatform",
          },
        ],
      };
      this.$axios
        .post(`/admapi/sys/conf/list`, param)
        .then(({ data }) => {
          this.options1 = data.items;
        })
        .catch()
        .finally();
    },
    goLink(val) {
      window.open(val.eventUrl, "_blank");
    },
  },
};
</script>
<style scoped>
.soldText {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}
</style>
